export default {
    en: {
        form: {
            firstName: "First name",
            lastName: "Last name",
            email: "Email",
            terms: "I accept the terms and conditions",
            type: "Select subscription type",
            additionalInfo: "Additional info",
            submitted: "The form is submitted!",
            sentInfo: "Here is the info you sent:",
            return: "Return to the form",
            submit: "Submit",
            submitting: "Submitting",
            charactersLeft: "You have {charCount} character left. | You have {charCount} characters left.",
            types: {
                free: "Free trial subscription",
                starter: "Starter subscription (50 € / month)",
                enterprise: "Enterprise subscription (250 € / month)"
            }
        },
        error: {
            invalidFields: "Following fields have an invalid or a missing value:",
            general: "An error happened during submit.",
            generalMessage: "Form sending failed due to technical problems. Try again later.",
            fieldRequired: "{field} is required.",
            fieldInvalid: "{field} is invalid or missing.",
            fieldMaxLength: "{field} maximum characters exceeded."
        }
    }
};
